import { useState } from "react";
import MixpanelLockModules from "src/mixpanel/mixpanelLockModule";
import { useSelector } from "src/redux/store";

const usePermissionDialog = () => {
  const [openModuleDialog, setOpenModuleDialog] = useState(false);
  let { showModalOnBlockedModule } = useSelector(
    (state: any) => state.organization.org
  );

  const handleCloseModuleDialog = () => {
    if (!showModalOnBlockedModule) return;
    setOpenModuleDialog(false);
    setModuleName("");
  };
  const handleOpenModuleDialog = (name: string) => {
    if (showModalOnBlockedModule) {
      setOpenModuleDialog(true);
      setModuleName(name);
    }
    MixpanelLockModules({
      eventName: "Locked Module",
      moduleName: name ?? "",
    });
  };
  const [moduleName, setModuleName] = useState("");

  return {
    handleCloseModuleDialog,
    handleOpenModuleDialog,
    moduleName,
    openModuleDialog,
  };
};
export default usePermissionDialog;
